import { Injectable } from "@angular/core";
import { select, Store } from "@ngrx/store";
import {
	AbstractTranslatableSnackBarService,
	CORE_ROUTE,
	CoreState,
	MessageType,
	ResponsibleGamingConfigService,
	SessionSelector,
	SessionSummaryAction,
	SessionSummarySelector,
} from "@obg/ngx.core";
import { TranslationService } from "@obg/ngx.core.content";
import { RouteAction } from "@obg/ngx.router";
import { filter, map, switchMap, withLatestFrom } from "rxjs/operators";

import { SESSION_EXPIRED_ALERT_ID } from "./session-expired-alert.const";

@Injectable({
	providedIn: "root",
})
export class SessionExpiredAlertService {
	constructor(
		private store: Store<CoreState>,
		private abstractTranslatableSnackBarService: AbstractTranslatableSnackBarService,
		private sessionSelector: SessionSelector,
		private responsibleGamingConfigService: ResponsibleGamingConfigService,
		private translationService: TranslationService
	) {}

	initialize$() {
		return this.store.pipe(
			select(this.sessionSelector.isSessionExpired()),
			filter((isExpired) => isExpired),
			switchMap(() =>
				this.store.select(SessionSummarySelector.get).pipe(
					map((sessionSummary) => {
						if (!sessionSummary) {
							return sessionSummary;
						}
						const translatedProducts = (
							sessionSummary?.productsUsed?.length ? sessionSummary.productsUsed : ["none"]
						).map((product) =>
							this.translationService.getByKey(`user-summary.session-summary-product-${product}`)
						);
						return { ...sessionSummary, productsUsed: translatedProducts };
					})
				)
			),
			withLatestFrom(this.responsibleGamingConfigService.getSessionSummaryEnabled$()),
			switchMap(([sessionSummary, sessionSummaryEnabled]) =>
				this.abstractTranslatableSnackBarService.openSnackBar$(
					{
						id: SESSION_EXPIRED_ALERT_ID,
						message:
							sessionSummary && sessionSummaryEnabled
								? "user-summary.session-timeout-message-with-session-summary"
								: "user-summary.session-timeout-message",
						buttons: [
							{
								text: "user-summary.login",
								handler: () => {
									this.store.dispatch(
										RouteAction.navigate(
											CORE_ROUTE.auth.login,
											{},
											{ queryParamsHandling: "preserve" }
										)
									),
										this.abstractTranslatableSnackBarService.dismissSnackBar();
								},
							},
						],
						dismissible: false,
						type: MessageType.Success,
						keepOpen: true,
					},
					[],
					sessionSummary
				)
			),
			map(() => SessionSummaryAction.clear())
		);
	}
}
